/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getProvinces = params => {
  return axios.get(`${base}/provincelist`, {params})
}

export const getCities = params => {
  return axios.get(`${base}/citylist_${params.pid}`, {params})
}

export const getDistricts = params => {
  return axios.get(`${base}/arealist_${params.pid}`, {params})
}

export const queryCitymap = params => {
  return axios.get(`${base}/query_citymap`, {params})
}

export const queryAllFormatted = params => {
  return axios.get(`${base}/query_all_formatted_citymap`, {params})
}

/**
 *
 *
 * @param id
 * @returns {*}
 */
export const getCityList = id => {
  return axios.get(`${base}/citylist_${id}`)
}
/**
 *
 *
 * @param params
 * @returns {*}
 */
export const getProvinceList = params => {
  return axios.get(`${base}/provincelist`)
}

/**
 * 根据区域id获取父级区域链
 *
 * @deprecated
 * @param id
 * @returns {*}
 */
export const getAreaChain = id => {
  return axios.get(`${base}/get_area_info_${id}`)
}



// WEBPACK FOOTER //
// ./src/views/area/area.api.js